import { useUserState } from "../context/UserContext";

const expectedApis = [
  "application",
  "auth",
  "plu",
  "report",
  "site",
  "version",
  "profile",
  "pluList",
  "employee",
  "user",
  "admin",
  "bradapi",
  "position_editor",
  "businessCalendar",
  "forecast",
  "budget",
  "about",
  "maxgp",
  "nutrition",
  "productinfo",
  "department",
  "rota",
  "stockcount",
  "noticeboard",
  "oliver",
  "eposmessenger",
  "email",
  "register",
  "notes",
  "company",
  "labour",
  "testReport",
  "webservice",
  "error",
  "tinashe",
  "OnlineBusinessSheet",
  "rewardCards",
  "stockapp",
  "vat",
  "checklist",
  "clockin",
  "booking",
  "table",
  "deposit",
  "pot",
  "ReportingApp",
  "pos",
  "emma",
  "hayley",
  
  "*",
  "?",
  "MaxCloud",
  "GSAdmin",
  "Module",
  "reportSet"
].map((a) => a.toLowerCase() );

const stringifyToLowerCase = function(input) {
  if (typeof(input) == "string") {
  return input.toLowerCase();
  }
  if (typeof(input) == "integer") {
  return input+""; // make it a string
  }
  if (input?.toString) {
  return input.toString().toLowerCase();
  }
  return (input+"").toLowerCase();
}

 export const checkPermissions =( userPermissions, permissions ) => {
  let { api = "*", page, action, strict = false } = permissions;
    let permitted = false;
    
    const normalisedQuery = {
      api : ((api instanceof Array) && api || [api]).map(v => stringifyToLowerCase(v)),
      page : ((page instanceof Array) && page || [page]).map(v => stringifyToLowerCase(v)),
      action : ((action instanceof Array) && action || [action]).map(v => stringifyToLowerCase(v))
    };
    
    // weak match can't overrider a strong match. Weak match is produced by a * 
    let strongMatchApi = false;
    let strongMatchPage = false;
    let strongMatchMatch = false;
    let override = false;

    userPermissions?.permissions?.forEach((rule) => {
    
      // we need to normalise the rules
      // first we include values from either singular or plural properties of the rule
      let normalisedRule = {
        api : rule.api || rule.apis,
        page : rule.page || rule.pages,
        action : rule.action || rule.actions,
        allow : !!rule.allow
      };
      // next we turn the values into arrays if theyre not arrays already
      normalisedRule.api = ((normalisedRule.api instanceof Array) && normalisedRule.api || [normalisedRule.api]).map(v => stringifyToLowerCase(v));
      normalisedRule.page = ((normalisedRule.page instanceof Array) && normalisedRule.page || [normalisedRule.page]).map(v => stringifyToLowerCase(v));
      normalisedRule.action = ((normalisedRule.action instanceof Array) && normalisedRule.action || [normalisedRule.action]).map(v => stringifyToLowerCase(v));
      
      normalisedRule.api.map(v => stringifyToLowerCase(v));
      normalisedRule.page.map(v => stringifyToLowerCase(v));
      normalisedRule.action.map(v => stringifyToLowerCase(v));
      

      override = normalisedRule.api.includes("gsadmin"); // gsadmin overrides all
      var apiMatch = ( ( normalisedRule.api.includes("*") || normalisedRule.api.includes("?") || normalisedQuery.api.includes("*") || normalisedQuery.api.includes("?") ) && 1 ) || 0;
      var pageMatch = ( ( normalisedRule.page.includes("*") || normalisedRule.page.includes("?") || normalisedQuery.page.includes("*") || normalisedQuery.page.includes("?") ) && 1 ) || 0;
      var actionMatch = ( ( normalisedRule.action.includes("*") || normalisedRule.action.includes("?") || normalisedQuery.action.includes("*") || normalisedQuery.action.includes("?") ) && 1 ) || 0;
      
      const apiIntersection = normalisedRule.api.filter( value => normalisedQuery.api.includes(value) && value != "*"  && value != "?" );
      const pageIntersection = normalisedRule.page.filter( value => normalisedQuery.page.includes(value) && value != "*"  && value != "?" );
      const actionIntersection = normalisedRule.action.filter( value => normalisedQuery.action.includes(value) && value !== "*"  && value !== "?" );
      
      // explicit matches have a higher match rating
      if ( apiIntersection.length > 0 ) apiMatch = 2;
      if ( pageIntersection.length > 0 ) pageMatch = 2;
      if ( actionIntersection.length > 0 ) actionMatch = 2;
      
   
      if ( !apiMatch || !pageMatch || !actionMatch ) {
        // doesn't match at all
      } else if ( strict && ( apiMatch > 1 || pageMatch > 1 || actionMatch > 1 ) ) {
        // satisfies strict
        // we might want some extra behaviour for strict checks
       
        permitted = !!normalisedRule.allow;
      } else if ( !strict ) {
        // satisfies non strict
        permitted = !!normalisedRule.allow;
      }
      
      // finally we need to add in some checks for unknown permissions which are being passed
      ( (api instanceof Array) && api || [api] ).forEach((thisApi) => {
        if ( expectedApis.indexOf(thisApi.toLowerCase()) === -1 ) console.log("Unexpected api in the permission Check :", thisApi);
      });
    });
    if (override) {
      permitted = true;
    }

    return permitted;
  
  
  // const getPermittedSites = ( permissions2, allSites, api, page, action, strict = false, debug = {} ) => {
  //   var allowedSites = "*"; // by default we allow all sites.
  //   var specificSites = [];
    
  //   var normalisedQuery = {
  //     api : ((api instanceof Array) && api || [api]).map(v => stringifyToLowerCase(v)),
  //     page : ((page instanceof Array) && page || [page]).map(v => stringifyToLowerCase(v)),
  //     action : ((action instanceof Array) && action || [action]).map(v => stringifyToLowerCase(v))
  //   };
    
  //   // we loop over all the rules, if the rule meets various checks AND (importantly) the rule has site information included, then we use that site information
  //   permissions2.forEach((rule) => {
  //     var normalisedRule = {
  //       api : rule.api || rule.apis,
  //       page : rule.page || rule.pages,
  //       action : rule.action || rule.actions,
  //       allow : !!rule.allow
  //     };
  //     // next we turn the values into arrays if theyre not arrays already
  //     normalisedRule.api = ((normalisedRule.api instanceof Array) && normalisedRule.api || [normalisedRule.api]).map(v => stringifyToLowerCase(v));
  //     normalisedRule.page = ((normalisedRule.page instanceof Array) && normalisedRule.page || [normalisedRule.page]).map(v => stringifyToLowerCase(v));
  //     normalisedRule.action = ((normalisedRule.action instanceof Array) && normalisedRule.action || [normalisedRule.action]).map(v => stringifyToLowerCase(v));
      
  //     normalisedRule.api.map(v => stringifyToLowerCase(v));
  //     normalisedRule.page.map(v => stringifyToLowerCase(v));
  //     normalisedRule.action.map(v => stringifyToLowerCase(v));
      
      
  //     var apiMatch = ( ( normalisedRule.api.includes("*") || normalisedRule.api.includes("?") || normalisedQuery.api.includes("*") || normalisedQuery.api.includes("?") ) && 1 ) || 0;
  //     var pageMatch = ( ( normalisedRule.page.includes("*") || normalisedRule.page.includes("?") || normalisedQuery.page.includes("*") || normalisedQuery.page.includes("?") ) && 1 ) || 0;
  //     var actionMatch = ( ( normalisedRule.action.includes("*") || normalisedRule.action.includes("?") || normalisedQuery.action.includes("*") || normalisedQuery.action.includes("?") ) && 1 ) || 0;
      
  //     const apiIntersection = normalisedRule.api.filter( value => normalisedQuery.api.includes(value) && value != "*"  && value != "?" );
  //     const pageIntersection = normalisedRule.page.filter( value => normalisedQuery.page.includes(value) && value != "*"  && value != "?" );
  //     const actionIntersection = normalisedRule.action.filter( value => normalisedQuery.action.includes(value) && value != "*"  && value != "?" );
      
  //     if ( apiIntersection.length > 0 ) apiMatch = 2;
  //     if ( pageIntersection.length > 0 ) pageMatch = 2;
  //     if ( actionIntersection.length > 0 ) actionMatch = 2;
     
  //     var permitted = false;
      
  //     if ( !apiMatch || !pageMatch || !actionMatch || !rule.sites ) {
  //       // doesn't match at all
  //     } else if ( strict && ( apiMatch > 1 || pageMatch > 1 || actionMatch > 1 ) ) {
  //       // satisfies strict
  //       // we might want some extra behaviour for strict checks
  //       permitted = !!normalisedRule.allow;
  //     } else if ( !strict ) {
  //       // satisfies non strict
  //       permitted = !!normalisedRule.allow;
  //     }
      
  //     if ( permitted ) {
  //       if ( rule.sites instanceof Array ) {
  //         allowedSites = rule.sites;
  //         rule.sites.forEach((siteRef) => {
  //           if ( specificSites.indexOf(parseInt(siteRef)) == -1 ) {
  //             specificSites.push(parseInt(siteRef));
  //           }
  //         });
  //       } else {
  //         allowedSites = [rule.sites];
  //         if ( specificSites.indexOf(parseInt(rule.sites)) == -1 ) {
  //           specificSites.push(parseInt(rule.sites));
  //         }
  //       }
  //     }
  //   });
  //   if (allowedSites == "*") {
  //     allowedSites = [];
  //     allSites.forEach((site) => {
  //       allowedSites.push(site.site_reference);
  //     });
  //   }
  //   if (specificSites.length > 0) {
  //     allowedSites = specificSites;
  //   }
  //   var permissionObject = {};
  //   var fakeProperties = {};
    
  //   // fake permission key values are added to new permissions if using the booking api
  //   if ( normalisedQuery.api.includes("booking") ) {
  //     fakeProperties = {
  //       canCreateDeposit : "1",
  //       canEditDeposit : "1",
  //       canCancelDeposit : "1",
  //       canRefundDeposit : "1",
  //       canTransferDeposit : "1",
  //     }
  //   }
  //   allowedSites.forEach((siteRef) => {
  //     permissionObject[siteRef] = { site_ref : siteRef, properties : fakeProperties };
  //   });
  //   return permissionObject;
  // }
  
  
};


// export const checkPermissions = (userPermissions, permissions) => {
//   let permitted = false;
//   let { api = "*", page, action, strict = false } = permissions;

//   const apiNorm = Array.isArray(api)
//     ? api.map((v) => v.toLowerCase())
//     : api?.toLowerCase();
//   const pageNorm = Array.isArray(page)
//     ? page.map((v) => v.toLowerCase())
//     : page?.toLowerCase();
//   const actionNorm = Array.isArray(action)
//     ? action.map((v) => v.toLowerCase())
//     : action?.toLowerCase();

//   userPermissions?.permissions.forEach((rule) => {
//     const ruleApi = Array.isArray(rule?.api)
//       ? rule?.api?.map((v) => v?.toLowerCase())
//       : rule?.api?.toLowerCase();
//     const rulePage = Array.isArray(rule?.page)
//       ? rule?.page.map((v) => v?.toLowerCase())
//       : rule?.page?.toLowerCase();
//     const ruleActions = Array.isArray(rule?.actions)
//       ? rule?.actions?.map((v) => v?.toLowerCase())
//       : rule?.actions?.toLowerCase();

//     var apiMatch =
//       apiNorm === "?" ||
//       apiNorm === "*" ||
//       ruleApi.includes("gsadmin") ||
//       (!ruleApi && apiNorm === "pos") ||
//       (!strict &&
//         ruleApi &&
//         apiNorm !== "reportset" &&
//         ruleApi.indexOf("*") !== -1) ||
//       (ruleApi && ruleApi.indexOf(apiNorm) !== -1);

//     var pageMatch =
//       ruleApi.includes("gsadmin") ||
//       pageNorm === "?" ||
//       pageNorm === "*" ||
//       (!strict && rulePage.indexOf("*") !== -1) ||
//       rulePage.indexOf(pageNorm) !== -1;

//     var actionMatch =
//       actionNorm === "?" ||
//       ruleApi.includes("gsadmin") ||
//       actionNorm === "*" ||
//       (!strict && ruleActions.indexOf("*") !== -1) ||
//       ruleActions.indexOf(actionNorm) !== -1;

//     if (Array.isArray(apiNorm)) {
//       const filteredArray = apiNorm.filter((value) => ruleApi.includes(value));
//       if (filteredArray.length > 0) apiMatch = true;
//     }

//     if (Array.isArray(pageNorm)) {
//       const filteredArray = pageNorm.filter((value) =>
//         rulePage.includes(value)
//       );
//       if (filteredArray.length > 0) pageMatch = true;
//     }

//     if (Array.isArray(actionNorm)) {
//       const filteredArray = actionNorm.filter((value) =>
//         ruleActions.includes(value)
//       );
//       if (filteredArray.length > 0) actionMatch = true;
//     }

//     if (apiMatch && pageMatch && actionMatch) {
//       permitted = !!rule.allow;
//     }
//   });
//   return permitted;
// };

const AccessControl = ({ unallowedPermissions, children, renderNoAccess }) => {
  const userPermission = useUserState();
  //   console.log(userPermission);
  const permitted = checkPermissions(userPermission, unallowedPermissions);
  if (permitted === false) {
    return renderNoAccess();
  }
  return children;
};

export default AccessControl;
